import React, { useContext } from "react";
import './navbar.style.scss';
import { AccountContext } from "../../../Contexts/main.context";
import { useEffect } from "react";

const NavBar = () => {

     const { clientAccounts, updateActionButtons, updateActiveClient, masked, updateOriginalID,updateActiveOutlet,activeClient } = useContext(AccountContext)

     const clientChanged = (id) => {
          switch (id) {
               case 'NEW':
                    console.log('New');
                    updateActiveOutlet('New');
                    // updateActionButtons([]);
                    // updateActiveClient([]);

                    break;
               case '-':
                    console.log('Clear');
                    updateActionButtons([]);
                    updateActiveClient([]);
                    break;

               case 'ALL':
                    console.log('All');
                    updateActionButtons([]);
                    updateActiveClient([]);
                    break;
               default:
                    const selectedClient = clientAccounts.find(client => String(client.ID) === String(id));
                    const extraLocations = Array.isArray(clientAccounts)
                         ? clientAccounts.filter(client => String(client.locationID) === String(id))
                         : [];
                    const locationCount = extraLocations.length;
                    if (selectedClient) {
                         selectedClient.LocationCount = locationCount;
                    }
                    const citationCount = selectedClient.citationCount;

                    updateActiveClient(selectedClient);
                    updateOriginalID(selectedClient.ID);

                    if (!selectedClient) {
                         console.warn("Client not found");
                         return;
                    }

                    const buttons = [
                         { icon: "map", selected: true, label: `Locations (${locationCount + 1})`, action: 'ViewLocation' },
                         { icon: "customer", selected: false, label: "View Customer", action: 'ViewCustomer' },
                         { icon: "editCustomer", selected: false, label: "Edit Customer", action: 'editCustomer' },
                         { icon: "edit", selected: false, label: `View Citations [${citationCount}]`, action: 'ViewCitations' },
                         // { icon: "add", selected: false, label: "Add Citations", action: 'AddCitation' },
                         // { icon: "follow", selected: false, label: "Follow Up", action: 'followUp' },
                         // { icon: "change", selected: false, label: "Change Log", action: 'changeLog' },
                    ];

                    updateActionButtons(buttons);
                    break;

          }

     };

     useEffect(() => {
          console.log("Active Client Changed:", activeClient);
     }, [activeClient]);

     return (
          <div className="navbar-wrapper">
               <div className="ms-auto d-flex flex-grow-1 gap-2 col-12 justify-content-end">
                    <div className="col-12 d-flex align-items-center gap-2">
                         <div className="text-white">Account:</div>
                         <div style={{ flex: 1 }}>
                              <select
                                   name="client"
                                   className="form-select w-100"
                                   onChange={(e) => clientChanged(e.target.value)}>
                                   <option value="-">Choose Client</option>
                                   <option value="NEW">NEW Client</option>
                                   {Array.isArray(clientAccounts) &&
                                        clientAccounts
                                             .filter(client => client.locationID === '0')
                                             .map((client, index) => (
                                                  <option key={index} value={client.ID}>
                                                       {client.companyName}
                                                  </option>
                                             ))
                                   }

                              </select>
                         </div>
                    </div>
               </div>
               {masked && (
                    <div className="navbar-mask-overlay"></div>
               )}
          </div>
     )
}

export default NavBar;